import React from 'react';

import {hooks} from '../hooks';
import {ArticlesType} from '../types';
  
type Props = {
  index: number;
  article: ArticlesType;
  isLast: boolean;
};

export const ArticlesItem: React.FC<Props> = ({index, article, isLast}) => {
  const navigate = hooks.useNavigate();

  return (
    <>
    <div
      onClick={() => navigate(`/detail-articles/${article.id}`, {state: {article}})}
    >
      <div style={{display: 'flex', gap: 16, marginBottom: 10}}>
        <img
          src={article.banner}
          alt={article.title}
          style={{maxWidth: 120, width: '100%', borderRadius: 6, height: 90, objectFit: 'cover', objectPosition: 'center'}}
        />
        <h5 className='number-of-lines-3' style={{marginBottom: 10, padding: '6px 0'}}>{article.title}</h5>
      </div>
      {/* <components.Name
        son={son.name}
        containerStyle={{marginBottom: 3}}
      /> */}
      <div style={{width: '100%'}}>
        <p
          className='t10'
          style={{lineHeight: 1.2, textAlign: 'right', position: 'absolute', right: 20, marginTop: -20}}
        >
          {article.date}
        </p>
        <p className='t12 number-of-lines-2' style={{marginBottom: 10, overflow: 'hidden'}}>{article.description}</p>
      </div>
    </div>
    </>
  );
};
